import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const BookingPageSkeleton = () => {
  return (
    <div className="min-h-screen gradient-mesh">
      {/* Exact Match Booking Header Skeleton */}
      <header className="sticky top-0 z-50 bg-background/80 backdrop-blur-xl border-b h-14 flex items-center justify-between px-4" style={{ paddingTop: 'env(safe-area-inset-top)' }}>
        <div className="flex items-center gap-3 w-full">
          <Button variant="ghost" size="icon" disabled className="h-8 w-8 -ml-2 rounded-full hidden md:flex shrink-0">
            <ChevronLeft className="h-5 w-5 opacity-30" />
          </Button>
          <div className="flex flex-col w-full">
             <div className="h-4 w-32 md:w-48 rounded bg-secondary/50 shimmer-wrapper opacity-20 mb-1.5" />
             <div className="h-2.5 w-16 md:w-24 rounded bg-secondary/30 shimmer-wrapper opacity-15" />
          </div>
        </div>
      </header>
      
      <main className="max-w-2xl mx-auto px-4 md:px-6 py-5 md:py-8 space-y-5 md:space-y-6 pb-28">
         {/* Exact Match ServiceSummary Card */}
         <div className="rounded-2xl border border-border/10 bg-card p-4 shadow-sm flex gap-4 overflow-hidden">
            <div className="h-16 w-16 md:h-20 md:w-20 shrink-0 rounded-xl bg-secondary/50 shimmer-wrapper opacity-20" />
            <div className="flex-1 space-y-3 py-0.5">
               <div className="h-4 w-3/4 md:w-2/3 rounded bg-secondary/50 shimmer-wrapper opacity-20" />
               <div className="flex items-center gap-2">
                 <div className="h-3.5 w-12 rounded bg-secondary/40 shimmer-wrapper opacity-20" />
                 <div className="h-3 w-4 rounded bg-secondary/20 shimmer-wrapper opacity-10" />
               </div>
               {/* Exact quantity selector mockup */}
               <div className="h-8 w-24 rounded-full bg-secondary/30 border border-border/10 shimmer-wrapper opacity-15 flex-shrink-0 mt-3" />
            </div>
         </div>

         {/* Exact Match BookingContactFields */}
         <div className="space-y-3">
            <div className="h-4 w-32 rounded bg-secondary/40 shimmer-wrapper opacity-20 mb-4" />
            <div className="h-12 w-full rounded-xl bg-secondary/10 border border-border/10 shimmer-wrapper opacity-15" />
            <div className="flex gap-3">
               <div className="h-12 w-24 rounded-xl bg-secondary/10 border border-border/10 shimmer-wrapper opacity-15" />
               <div className="h-12 flex-1 rounded-xl bg-secondary/10 border border-border/10 shimmer-wrapper opacity-15" />
            </div>
         </div>

         {/* Exact Match DateTimeSelector */}
         <div className="space-y-3 pt-2">
            <div className="h-4 w-40 rounded bg-secondary/40 shimmer-wrapper opacity-20 mb-4" />
            <div className="flex gap-2 overflow-hidden">
               {[1, 2, 3, 4, 5].map(i => (
                  <div key={i} className="h-[74px] w-16 shrink-0 rounded-2xl bg-secondary/10 border border-border/10 shimmer-wrapper opacity-15" />
               ))}
            </div>
            <div className="grid grid-cols-3 md:grid-cols-4 gap-2 mt-4">
               {[1, 2, 3, 4, 5, 6].map(i => (
                  <div key={i} className="h-11 rounded-xl bg-secondary/10 border border-border/10 shimmer-wrapper opacity-15" />
               ))}
            </div>
         </div>

         {/* Exact Match Address Block */}
         <div className="space-y-3 pt-2">
            <div className="flex items-center justify-between mb-4">
              <div className="h-4 w-32 rounded bg-secondary/40 shimmer-wrapper opacity-20" />
              <div className="h-4 w-16 rounded bg-secondary/30 shimmer-wrapper opacity-15 hidden md:block" />
            </div>
            {/* Map Placeholder */}
            <div className="h-[200px] w-full rounded-2xl bg-secondary/10 border border-border/10 shimmer-wrapper opacity-15 relative overflow-hidden">
               <div className="absolute inset-0 flex items-center justify-center">
                 <div className="h-8 w-8 rounded-full bg-secondary/30 shimmer-wrapper opacity-20" />
               </div>
            </div>
         </div>
         
         {/* Exact Match Payment Method Block */}
         <div className="space-y-3 pt-2">
            <div className="h-4 w-32 rounded bg-secondary/40 shimmer-wrapper opacity-20 mb-4" />
            <div className="grid grid-cols-2 gap-3">
              <div className="h-16 w-full rounded-xl bg-secondary/10 border border-border/10 shimmer-wrapper opacity-15" />
              <div className="h-16 w-full rounded-xl bg-secondary/10 border border-border/10 shimmer-wrapper opacity-15" />
            </div>
         </div>
      </main>

      {/* Exact Match Sticky Bottom */}
      <div className="fixed bottom-0 left-0 right-0 bg-card py-4 px-4 border-t flex flex-col gap-2 rounded-t-3xl shadow-[0_-10px_40px_rgba(0,0,0,0.1)] z-50">
         <div className="max-w-2xl mx-auto w-full">
            <div className="flex justify-between items-center px-2 py-1 mb-2">
               <div className="h-3 w-24 rounded bg-secondary/30 shimmer-wrapper opacity-20" />
               <div className="h-6 w-20 rounded bg-secondary/40 shimmer-wrapper opacity-30" />
            </div>
            <div className="h-14 w-full rounded-2xl bg-secondary/30 shimmer-wrapper opacity-40" />
         </div>
      </div>
    </div>
  );
};

export default BookingPageSkeleton;
